// Figma: https://www.figma.com/design/S3yxsM3h4CuTy6ZZjxpedQ/NEW-TSAB-Customer-App?node-id=TODO

import classnames from 'classnames'

export default function CloseButton({ innerRef, onClick, small, disabled, className }) {
  return (
    <div
      ref={innerRef}
      className={classnames('absolute top-3 right-4 pointer-events-auto', className)}
      style={disabled ? { pointerEvents: 'none' } : {}}
    >
      <button
        type="button"
        onClick={disabled ? undefined : onClick}
        disabled={disabled}
        className={classnames(
          'block disabled:cursor-not-allowed disabled:opacity-50',
          'group',
          small ? 'w-8' : 'w-8 app-md:w-12',
        )}
      >
        <svg
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={small ? 'w-full h-8' : 'w-full h-8 app-md:h-12'}
        >
          <circle
            cx="24" cy="24" r="24"
            className="fill-black/5 transition-[fill] duration-200 group-hover:fill-app-yellow"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M24.1424 25.4142L26.9708 28.2426L28.385 26.8284L25.5566 24L28.385 21.1716L26.9708 19.7574L24.1424 22.5858L21.3139 19.7574L19.8997 21.1716L22.7281 24L19.8997 26.8284L21.3139 28.2426L24.1424 25.4142Z"
            className="fill-black/50 transition-opacity duration-200 group-hover:opacity-100"
          />
        </svg>
      </button>
    </div>
  )
}
